import React, { useState, useEffect } from "react";
import { toastError } from "../utils/AppFunctions";
import { useNavigate } from "react-router-dom";
import UseTranslationHook from "../hooks/UseTranslationHook";
import { routePublic } from "../routes/PublicRoutePath";
import { ICButton } from "../core-component/ui";
import { fetchSystemSettingsByConfigKey } from "./system-settings/SystemSettingController";
import {
  LOGOUT_REASON_ENUM,
  SYSTEM_CONFIGURATION_KEYS,
} from "../utils/AppEnumerations";
import { LOGOUT_CURRENT_SESSION } from "../services/Endpoints";
interface Props {}

const SessionTimeoutModal: React.FC<Props> = (props) => {
  const { t } = UseTranslationHook();
  const navigate = useNavigate();
  const [showSessionTimeoutModal, setShowSessionTimeoutModal] = useState(false);
  const [openSessionTimeoutModal, setOpenSessionTimeoutModal] = useState(false);
  const [logoutFromSession, setLogoutFromSession] = useState(false);
  const [sit, setSit] = useState(2);
  const [ita, setIta] = useState(1);
  const [idSIT, setIdSIT] = useState<NodeJS.Timeout | null>(null);
  const [idITA, setIdITA] = useState<NodeJS.Timeout | null>(null);
  const [idSAC, setIdSAC] = useState<NodeJS.Timeout | null>(null);
  const [sessionAlertCounter, setSessionAlertCounter] = useState(0);
  const [keyPress, setKeyPress] = useState(0);
  const [idHandleEventTimer, setIdHandleEventTimer] =
    useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    fetchData();

    document.addEventListener("keydown", sessionEventListener);
    document.addEventListener("click", sessionEventListener);
    return () => {
      document.removeEventListener("keydown", sessionEventListener);
      document.removeEventListener("click", sessionEventListener);
      if (idSIT) clearTimeout(idSIT);
      if (idITA) clearTimeout(idITA);
      if (idHandleEventTimer) clearTimeout(idHandleEventTimer);
      if (idSAC) clearInterval(idSAC);
    };
  }, []);

  useEffect(() => {
    if (sit !== 0 && ita !== 0) {
      setSessionAlertCounter((sit - ita) * 60);
      initializeSystemIdleTimeout();
    }
  }, [sit, ita]);

  useEffect(() => {
    if (openSessionTimeoutModal) {
      setOpenSessionTimeoutModal(false);
      handleOpenSessionTimeoutModal();
    }
  }, [openSessionTimeoutModal]);

  useEffect(() => {
    if (logoutFromSession) {
      setLogoutFromSession(false);
      handleLogoutFromSession();
    }
  }, [logoutFromSession]);

  useEffect(() => {
    if (keyPress !== 0) {
      handleMouseKeyboardEvent();
    }
  }, [keyPress]);

  const fetchData = async () => {
    try {
      const sessionTimeOut = await fetchSystemSettingsByConfigKey(
        SYSTEM_CONFIGURATION_KEYS.SystemIdelTimeout
      );
      setSit(Number(sessionTimeOut));
      const sessionTimeOutAlert = await fetchSystemSettingsByConfigKey(
        SYSTEM_CONFIGURATION_KEYS.SystemIdelTimeoutAlert
      );
      setIta(Number(sessionTimeOutAlert));
    } catch (e) {
      toastError("globalUnknownErrorTryAgain");
    }
  };

  const sessionEventListener = (event: Event) => {
    setKeyPress((prev) => (prev >= 1000 ? 1 : prev + 1));
  };

  const handleMouseKeyboardEvent = () => {
    if (idHandleEventTimer) {
      clearTimeout(idHandleEventTimer);
    }
    if (!showSessionTimeoutModal) {
      const tempHandleEventTimer = setTimeout(() => {
        initializeSystemIdleTimeout();
      }, 1000);
      setIdHandleEventTimer(tempHandleEventTimer);
    }
  };

  const clearAllTimer = () => {
    if (idSIT) clearTimeout(idSIT);
    if (idITA) clearTimeout(idITA);
    if (idSAC) clearInterval(idSAC);
    setSessionAlertCounter((sit - ita) * 60);
  };

  const initializeSystemIdleTimeout = () => {
    clearAllTimer();
    const tempIdSIT = setTimeout(() => {
      setLogoutFromSession(true);
    }, sit * 60000);
    const tempIdITA = setTimeout(
      () => setOpenSessionTimeoutModal(true),
      ita * 60000
    );
    setIdSIT(tempIdSIT);
    setIdITA(tempIdITA);
  };

  const handleOpenSessionTimeoutModal = () => {
    setShowSessionTimeoutModal(true);
    const tempIdSAC = setInterval(
      () => setSessionAlertCounter((prev) => prev - 1),
      1000
    );
    setIdSAC(tempIdSAC);
  };

  const closeSessionTimeoutModal = (status: boolean) => {
    setShowSessionTimeoutModal(false);
    if (status) {
      handleLogoutFromSession();
    } else {
      initializeSystemIdleTimeout();
    }
  };

  const handleLogoutFromSession = async () => {
    try {
      clearAllTimer();
      await logout();
    } catch (e) {}
  };

  const logout = async () => {
    LOGOUT_CURRENT_SESSION(LOGOUT_REASON_ENUM.IdleTimeout);
    navigate("/" + routePublic.login);
  };

  return (
    <>
      {showSessionTimeoutModal && (
        <div className="modal-overlay-model  py-5 z-50">
          <div className="modal-custom lg:w-1/2 w-[350px]">
            <div className="custom-modal-div">
              <h2 className="title-custom-model py-2">
                {t("session_time_out_title")}
              </h2>
            </div>
            <div>
              <hr className="button-horizontal-line-space" />
              <div className="mt-2">
                <div className="text-center w-100">
                  <p className="flex mb-1 text-4">
                    {t("session_time_out_message")}
                  </p>
                </div>
                <div className="flex justify-center mt-4">
                  <ICButton
                    className="mr-2 px-4 bg-danger-emphasis"
                    onClick={() => closeSessionTimeoutModal(true)}
                  >
                    {t("session_log_of")}
                  </ICButton>
                  <ICButton
                    className="px-4 confirm-button-model ml-10"
                    onClick={() => closeSessionTimeoutModal(false)}
                  >{`STAY LOGGED IN (${
                    sessionAlertCounter >= 0 ? sessionAlertCounter : 0
                  })`}</ICButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionTimeoutModal;
